import React, {
    useState }             from 'react';

import * as images         from '../images/';
import Alert               from '../utils/Alert';
import intelitransit       from '../utils/InteliTransit';
import ErrorBoundary       from '../components/ErrorBoundary';
import HeaderAlertContext  from '../contexts/HeaderAlertContext';

const timesStyle = {
    position        : 'absolute' as ('absolute'|'relative'|undefined),
    width           : '36px',
    height          : '30px',
    right           : '0px',
    top             : '8px',
    border          : 'none',
    background      : 'none',
    color           : '#3e4676'
};

const backgroundByRole = {
    'Applicant'     : '#80873e',
    'Clerk'         : '#3e4676',
    'Manager'    : '#3e7c87',
} as Record<string,string>;

export const height = 60;

interface Props {
    title       : string|React.ReactNode;
    background? : string;
    children?   : React.ReactNode;
    logoutTitle?: string;
    onLogout?   : () => void;
}

export const MenuItem : React.FC<Props> = props => {
    const [alertMessage,setAlertMessage] = useState<string>('');
    class HeaderAlert extends Alert {
        set( message?:string, timeout?:number ) : Alert {
            // Carefully update alert to avoid the following nightmare screnario:
            // 1/ An component uses HeaderAlertContext and does rendering
            // 2/ An error happens during the render and alert is set
            // 3/ Setting alert changes the state of <MenuItem/>
            // 4/ This causes the <MenuItem/> to re-render and re-render all the children
            // 5/ The component from step 1/ re-rendered and sets alert again
            // 6/ We fall into an endless loop of re-renderings
            if( this.message!==message ) {
                this.message = message;
                if( message ) {
                    // Setup cleaning up after timeout if was requested
                    if( timeout )
                        window.setTimeout(()=>setAlertMessage(''),timeout);
                }
                setAlertMessage(this.message||''); // and re-render
            }
            return this;
        }
    };
    const roleBackground = backgroundByRole[window.location.href.replace(/^https?:\/\/[^/]+\/([^/]+)\/.+$/,"$1")]
        || backgroundByRole['Clerk'];
    const [headerStyle, setHeaderStyle] = React.useState<any>({});
    const [alertMessageStyle, setAlertMessageStyle] = React.useState<any>({});
    React.useEffect(()=>{
        const widthStyles  = {
        };
        setHeaderStyle({
            top : "0px",
            height:`${height}px`,
            background:(props.background||roleBackground),
            zIndex:999,
            ...widthStyles
        });
        setAlertMessageStyle({
            zIndex:999,
            ...widthStyles
        });
    },[roleBackground,props.background]);

    return (
        <ErrorBoundary>
            <HeaderAlertContext.Provider value={new HeaderAlert(alertMessage)}>
            <div className="header" style={headerStyle}>
                <span className="header__brand">{intelitransit.agency?.name||'TECTRANSIT'}</span>
                <span className="header__title">{props.title}</span>
                <span className="header__logout"
                    title       = {props.logoutTitle||"log out"}
                    style       = {{
                        cursor : 'pointer'
                    }}
                    onClick     = {(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if( typeof props.onLogout === 'function' )
                            return props.onLogout();
                        window.location.href = '/auth/logout';
                    }}
                >
                    <images.Logout/>
                </span>
            </div>
            { alertMessage && (
                <div className="alert-message" style={alertMessageStyle}>
                    <div className="alert-message__inner">
                        <images.Alert/>
                        <span>{alertMessage}</span>
                    </div>
                    <button style={timesStyle} className="close" aria-label="Close" onClick={()=>{setAlertMessage('')}}>
                        <images.Close/>
                    </button>
                </div>
            )}
            <div style={{paddingTop:alertMessage?`3 rem`:`0`}}>
                {props.children}
            </div>
            </HeaderAlertContext.Provider>
        </ErrorBoundary>
    );
}

export const withAlert = ( proc:(alert:Alert)=>(string|React.ReactNode) ) : React.ReactElement => {
    return (<HeaderAlertContext.Consumer>{(alert:Alert)=>proc(alert)}</HeaderAlertContext.Consumer>);
};

export const withMenuItem = ( title:(string|React.ReactNode), proc:(alert:Alert)=>(string|React.ReactNode) ) : React.ReactElement => {
    return (<MenuItem title={title}>{withAlert(proc)}</MenuItem>);
};

export default MenuItem;

